module.exports = "https://www.gc-pro.gnp.com.mx/c76a5c9ffeab531a2d013d0099e2dbbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notification-icon.png
// module id = 8155
// module chunks = 0